
document.addEventListener('DOMContentLoaded', function() {
  const roadmapSection = document.querySelector('.roadmap-section-template--30445709951324__roadmap_kbCmFF');
  if (!roadmapSection) return;

  // Handle roadmap button functionality
  const roadmapButtons = roadmapSection.querySelectorAll('.roadmap-cta-button');
  roadmapButtons.forEach(button => {
    // Prevent default behavior for buttons with href="#" that are not scroll buttons
    if (button.getAttribute('href') === '#' && !button.hasAttribute('data-scroll-to-top')) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        console.warn('⚠️ Roadmap button clicked but no valid redirect URL is set. Please configure the product or URL in the section settings.');
      });
    }

    // Handle scroll-to-top functionality
    if (button.hasAttribute('data-scroll-to-top')) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }
  });
  
  const timeline = roadmapSection.querySelector('.roadmap-timeline');
  const timelineFill = roadmapSection.querySelector('.timeline-fill');
  const roadmapItems = roadmapSection.querySelectorAll('.roadmap-item');
  
  if (!timeline || !timelineFill || roadmapItems.length === 0) return;
  
  function updateTimelineFill() {
    const sectionRect = roadmapSection.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    
    // Calculate how much of the section is visible
    const sectionTop = sectionRect.top;
    const sectionBottom = sectionRect.bottom;
    
    // Start filling when section enters viewport
    if (sectionBottom < 0 || sectionTop > viewportHeight) {
      timelineFill.style.height = '0%';
      return;
    }
    
    // Calculate progress based on roadmap items, not the entire timeline container
    let progress = 0;
    
    if (roadmapItems.length > 0) {
      // Get the position of the last roadmap item
      const lastItem = roadmapItems[roadmapItems.length - 1];
      const lastItemRect = lastItem.getBoundingClientRect();
      const lastItemBottom = lastItemRect.bottom;
      
      // Calculate progress based on scroll position relative to roadmap items
      if (sectionTop <= viewportHeight && sectionBottom >= 0) {
        // Calculate how much we've scrolled through the roadmap items area
        const visibleTop = Math.max(0, -sectionTop);
        
        // Use the distance from section top to last item bottom as the reference height
        const itemsHeight = lastItemBottom - sectionRect.top;
        
        // Calculate progress, but cap it so it doesn't go beyond the last item
        progress = Math.min(1, visibleTop / (itemsHeight * 0.8));
      }
    }
    
    // Ensure progress is between 0 and 1
    progress = Math.max(0, Math.min(1, progress));
    
    // Apply the fill height directly to the element
    const fillHeight = progress * 100;
    timelineFill.style.height = fillHeight + '%';
    
    // Debug logging (remove in production)
    console.log('Roadmap fill progress:', progress, 'height:', fillHeight + '%', 'items:', roadmapItems.length);
  }
  
  // Throttle scroll events for better performance
  let ticking = false;
  function handleScroll() {
    if (!ticking) {
      requestAnimationFrame(function() {
        updateTimelineFill();
        ticking = false;
      });
      ticking = true;
    }
  }
  
  // Initial calculation
  updateTimelineFill();
  
  // Listen for scroll events
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', updateTimelineFill);
  
  // Debug logging
  console.log('Roadmap script initialized');
  console.log('Timeline fill element:', timelineFill);
  console.log('Timeline element:', timeline);
  console.log('Roadmap section:', roadmapSection);

  // Animate roadmap items on scroll
  const roadmapItemsToAnimate = roadmapSection.querySelectorAll('.roadmap-item');
  
  if (roadmapItemsToAnimate.length > 0) {
    // Check if Intersection Observer is supported
    if ('IntersectionObserver' in window) {
      const observerOptions = {
        threshold: 0.2,
        rootMargin: '0px 0px -100px 0px'
      };

      const itemObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Item is coming into view - animate in
            entry.target.classList.remove('fade-out');
            entry.target.classList.add('animate-in');
          } else {
            // Item is going out of view - animate out
            entry.target.classList.remove('animate-in');
            entry.target.classList.add('fade-out');
          }
        });
      }, observerOptions);

      // Start observing each roadmap item with staggered delays
      roadmapItemsToAnimate.forEach((item, index) => {
        // Initially set items to fade-out state
        item.classList.add('fade-out');
        // Add a small delay for staggered animation effect
        item.style.transitionDelay = `${index * 0.1}s`;
        itemObserver.observe(item);
      });
    } else {
      // Fallback for browsers without Intersection Observer support
      // Use scroll event listener
      let ticking = false;
      
      function checkItemsVisibility() {
        const viewportHeight = window.innerHeight;
        
        roadmapItemsToAnimate.forEach((item) => {
          const rect = item.getBoundingClientRect();
          const isVisible = rect.top < viewportHeight * 0.8 && rect.bottom > viewportHeight * 0.2;
          
          if (isVisible) {
            item.classList.remove('fade-out');
            item.classList.add('animate-in');
          } else {
            item.classList.remove('animate-in');
            item.classList.add('fade-out');
          }
        });
        
        ticking = false;
      }
      
      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(checkItemsVisibility);
          ticking = true;
        }
      }
      
      // Initial check
      roadmapItemsToAnimate.forEach((item, index) => {
        item.classList.add('fade-out');
        item.style.transitionDelay = `${index * 0.1}s`;
      });
      
      checkItemsVisibility();
      window.addEventListener('scroll', onScroll);
    }
  }
});
